import { apiInstance, legacyV2Path } from '../index'
import { mapArgs } from 'corp-front-vue-commons/src/utils/functions'

const accounts = {
  get (companyId, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/company/${companyId}/accounts`,
      params
    })
  }
}

export default accounts
